import { ConsultationInvoiceTypeEnum } from '../../api/generated';

export { default as ListConsultations } from './list-consultations';
export { default as ShowConsultations } from './show-consultations';

export const ConsultationInvoicesTypeChoices = [
    {id: ConsultationInvoiceTypeEnum.Initiation, name: 'Вступительный'},
    {id: ConsultationInvoiceTypeEnum.Prolongation, name: 'Продление'},
];
